import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../assets/Images/icono-instector.png'
import _imports_1 from '../../assets/Images/icono-realtor.png'
import _imports_2 from '../../assets/Images/icono-titulo.png'
import _imports_3 from '../../assets/Images/logo2.png'


const _hoisted_1 = { class: "tw-flex tw-justify-between tw-items-center tw-bg-white tw-px-8 tw-py-5" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-p-0 tw-gap-3" }
const _hoisted_3 = {
  key: 0,
  class: "tw-h-[70px] tw-w[70px]",
  src: _imports_0,
  alt: ""
}
const _hoisted_4 = {
  key: 1,
  class: "tw-h-[70px] tw-w[70px]",
  src: _imports_1,
  alt: ""
}
const _hoisted_5 = {
  key: 2,
  class: "tw-h-[70px] tw-w[70px]",
  src: _imports_2,
  alt: ""
}
const _hoisted_6 = {
  key: 3,
  class: "tw-h-[70px] tw-w[70px]",
  src: _imports_0,
  alt: ""
}
const _hoisted_7 = { class: "tw-text-[#0080A3] tw-text-[40px] tw-font-normal tw-block" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "tw-w-[200px]" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  })
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "tw-pt-4 tw-px-4 tw-bg-[#E6E7E8]" }, null, -1)
const _hoisted_10 = { class: "tw-px-4 tw-mt-4" }
const _hoisted_11 = { class: "tw-bg-white tw-rounded-tl-3xl tw-rounded-tr-3xl tw-text-left tw-px-7 tw-py-5 tw-shadow-lg tw-z-[0.5]" }
const _hoisted_12 = { class: "tw-flex tw-w-2/3 tw-mt-3 tw-justify-start tw-items-center tw-gap-5" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_14 = { class: "tw-position-relative" }
const _hoisted_15 = {
  class: "modal fade",
  id: "exampleModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_16 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg" }
const _hoisted_17 = { class: "modal-content" }
const _hoisted_18 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "tw-font-semibold tw-text-xl" }, "MESSAGE")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "tw-flex" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "tw-font-semibold tw-px-1" }, "DATE: ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = { class: "tw-text-left" }
const _hoisted_25 = { class: "tw-font-semibold tw-uppercase" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "NAME: ", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, "PHONE NUMBER: ", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, "EMAIL: ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, "STATE: ", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", null, "COUNTY: ", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, "zip: ", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", null, "section: ", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "tw-text-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "tw-font-semibold" }, "MESSAGE")
], -1)
const _hoisted_35 = { class: "tw-text-justify" }
const _hoisted_36 = { class: "tw-break-all tw-w-full" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "accept btn btn-secondary",
    "data-bs-dismiss": "modal"
  }, "Close")
], -1)
const _hoisted_38 = { class: "tw-bg-white tw-w-full tw-rounded-bl-3xl tw-rounded-br-3xl tw-px-7 tw-py-5 tw-flex-col gap-y-" }
const _hoisted_39 = { class: "tw-flex tw-flex-col tw-gap-5 tw-justify-between tw-fle tw-items-start tw-w-full tw-null tw-mb-4" }
const _hoisted_40 = { class: "tw-flex tw-justify-start gap-3 tw-w-full" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope message" }, null, -1)
const _hoisted_43 = { class: "123 tw-text-left tw-w-full" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", { class: "tw-text-[#656565] tw-font-bold" }, "Support Message", -1)
const _hoisted_45 = { class: "tw-truncate tw-overflow-hidden tw-block" }
const _hoisted_46 = {
  key: 0,
  class: "tw-w-1/3"
}
const _hoisted_47 = { class: "tw-flex tw-justify-end tw-items-center tw-pr-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_datepicker = _resolveComponent("datepicker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_loading, {
      active: _ctx.loaderConfig.isLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loaderConfig.isLoading) = $event)),
      "can-cancel": false,
      loader: 'dots',
      "is-full-page": !_ctx.loaderConfig.fullPage
    }, null, 8, ["active", "is-full-page"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.userRole == 'Inspector' || _ctx.userRole == 'Realtor')
          ? (_openBlock(), _createElementBlock("img", _hoisted_3))
          : _createCommentVNode("", true),
        (_ctx.userRole == 'Admin')
          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
          : _createCommentVNode("", true),
        (_ctx.userRole == 'Title Company')
          ? (_openBlock(), _createElementBlock("img", _hoisted_5))
          : _createCommentVNode("", true),
        (_ctx.userRole == 'MLO')
          ? (_openBlock(), _createElementBlock("img", _hoisted_6))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.userRole == "MORTGAGE LOAN ORIGINATOR" ? "":_ctx.userRole), 1)
      ]),
      _hoisted_8
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_datepicker, {
            "auto-apply": "",
            class: "w-50",
            range: "",
            "text-input": _ctx.configDatePicker,
            modelValue: _ctx.configDatePicker.date,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => ((_ctx.configDatePicker.date) = $event)),
              _ctx.changeDate
            ],
            placeholder: "Enter date range..."
          }, null, 8, ["text-input", "modelValue", "onUpdate:modelValue"])
        ])
      ]),
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              (_ctx.selectedmessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _hoisted_19,
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("span", null, _toDisplayString(_ctx.selectedmessage.date1), 1)
                    ]),
                    _hoisted_23,
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.selectedmessage.user.tipo_rol), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_26,
                        _createElementVNode("span", null, _toDisplayString(_ctx.selectedmessage.user.username + " " + _ctx.selectedmessage.user.lastname), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_27,
                        _createElementVNode("span", null, _toDisplayString(_ctx.selectedmessage.user.phone_Number), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_28,
                        _createElementVNode("span", null, _toDisplayString(_ctx.selectedmessage.user.email), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_29,
                        _createElementVNode("span", null, _toDisplayString(_ctx.selectedmessage.user.state), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_30,
                        _createElementVNode("span", null, _toDisplayString(_ctx.selectedmessage.user.country), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_31,
                        _createElementVNode("span", null, _toDisplayString(_ctx.selectedmessage.user.zipcode), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_32,
                        _createElementVNode("span", null, _toDisplayString(_ctx.selectedmessage.user.section), 1)
                      ])
                    ]),
                    _hoisted_33,
                    _hoisted_34,
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.selectedmessage.message), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_37
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listMessages, (message) => {
            return (_openBlock(), _createElementBlock("div", null, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", {
                    type: "button",
                    class: "user-message tw-flex tw-items-center tw-justify-between tw-text-black tw-w-full",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#exampleModal",
                    onClick: ($event: any) => (_ctx.selectMessage(message))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["tw-flex tw-justify-start tw-gap-5", { 'tw-w-1/3': _ctx.usersession.role != 'Realtor', 'tw-w-1/2': _ctx.usersession.role != 'Realtor' }])
                    }, [
                      _hoisted_42,
                      _createElementVNode("div", _hoisted_43, [
                        _hoisted_44,
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_45, _toDisplayString(message.message), 1)
                        ])
                      ])
                    ], 2),
                    (_ctx.usersession.role != 'Realtor')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _createElementVNode("span", null, _toDisplayString(message.user.username), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass({ 'tw-w-1/3': _ctx.usersession.role != 'Realtor', 'tw-w-1/2': _ctx.usersession.role != 'Realtor' })
                    }, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("span", null, _toDisplayString(message.date1), 1)
                      ])
                    ], 2)
                  ], 8, _hoisted_41)
                ])
              ])
            ]))
          }), 256))
        ])
      ])
    ])
  ]))
}